module.exports = "/_next/static/images/10757398eb234c93720474e3bae8e6c1-slide-2-large.png.webp";